import { render, staticRenderFns } from "./advertisementadd.vue?vue&type=template&id=7f36fe8e&scoped=true&"
import script from "./advertisementadd.vue?vue&type=script&lang=js&"
export * from "./advertisementadd.vue?vue&type=script&lang=js&"
import style0 from "./advertisementadd.vue?vue&type=style&index=0&id=7f36fe8e&lang=stylus&scoped=true&"
import style1 from "./advertisementadd.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36fe8e",
  null
  
)

component.options.__file = "advertisementadd.vue"
export default component.exports